import React from "react";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
// import { fetchIntegrationToken } from "../helper/api";
import { useUserSubscriptionData } from "../helper/hooks";

export const GlobalComponent = () => {
  const dispatch = useDispatch();
  const member = useSelector(state => get(state, ["member"], null));

  React.useEffect(() => {
    // fetchIntegrationToken(dispatch);
  }, [member]);

  React.useEffect(() => {
    // fetchIntegrationToken(dispatch);
    useUserSubscriptionData(dispatch);
  }, []);

  return <React.Fragment />;
};
